import appGlobalScript from '/runner/_work/profit-time-triforce-widget/profit-time-triforce-widget/triforce-web-components/src/analytics/AnalyticsSetup.ts';
export const globalScripts = appGlobalScript;
